import { Plus, Trash2, GripVertical } from 'lucide-react';
import { FormSection as FormSectionType } from '../../types/formBuilder';
import { FormFieldComponent } from './FormField';

interface FormSectionProps {
  section: FormSectionType;
  canRemove: boolean;
  onUpdateTitle: (sectionId: string, title: string) => void;
  onAddField: (sectionId: string) => void;
  onRemoveSection: (sectionId: string) => void;
  onUpdateField: (sectionId: string, fieldId: string, updates: Partial<FormSectionType['fields'][0]>) => void;
  onRemoveField: (sectionId: string, fieldId: string) => void;
  onOpenFieldSettings: (sectionId: string, fieldId: string) => void;
  onMoveFieldUp: (sectionId: string, fieldIndex: number) => void;
  onMoveFieldDown: (sectionId: string, fieldIndex: number) => void;
}

export const FormSection = ({
  section,
  canRemove,
  onUpdateTitle,
  onAddField,
  onRemoveSection,
  onUpdateField,
  onRemoveField,
  onOpenFieldSettings,
  onMoveFieldUp,
  onMoveFieldDown
}: FormSectionProps) => {
  
  return (
    <div className="card p-6">
      {/* Section Header */}
      <div className="flex items-center justify-between mb-6 pb-4 border-b border-subtle">
        <div className="flex items-center space-x-3 flex-1">
          <GripVertical className="w-5 h-5 text-th-secondary cursor-move" />
          <input
            type="text"
            value={section.title}
            onChange={(e) => onUpdateTitle(section.id, e.target.value)}
            placeholder="Section title"
            className="flex-1 bg-transparent text-lg font-semibold text-th-primary border-none outline-none focus:bg-elevated px-2 py-1 rounded transition-all"
          />
        </div>
        <div className="flex items-center space-x-2">
          <button
            onClick={() => onAddField(section.id)}
            className="p-2 text-th-secondary hover:text-brand transition-colors rounded-lg hover:bg-overlay"
            title="Add Field"
          >
            <Plus className="w-4 h-4" />
          </button>
          {canRemove && (
            <button
              onClick={() => onRemoveSection(section.id)}
              className="p-2 text-th-secondary hover:text-status-error transition-colors rounded-lg hover:bg-status-error/10"
              title="Remove Section"
            >
              <Trash2 className="w-4 h-4" />
            </button>
          )}
        </div>
      </div>

      {/* Fields */}
      <div className="space-y-4">
        {section.fields.map((field, index) => (
          <FormFieldComponent
            key={field.id}
            field={field}
            sectionId={section.id}
            fieldIndex={index}
            totalFields={section.fields.length}
            canRemove={section.fields.length > 1}
            onUpdate={onUpdateField}
            onRemove={onRemoveField}
            onOpenSettings={onOpenFieldSettings}
            onMoveUp={onMoveFieldUp}
            onMoveDown={onMoveFieldDown}
          />
        ))}
      </div>
    </div>
  );
};